
// 👇 your youtube items (add more here)
const YoutubeNews = [
    {
    
    id: "A_t1dUIfTvs",
    title:
      "गौमाया x भारत धारा x Sevyam HiiMS — नि:शुल्क स्वास्थ्य जाँच व चिकित्सा शिविर (जयपुर) सम्पन्न",
    url: "https://www.youtube.com/post/UgkxgHhhpUqqRPO4xItx5-Q4GrkgB2JUMX70",
  },
  {
    
    id: "UmSyUkmMXYg",
    title:
      "Ex-Patanjali Patient: ३-दिन शिविर, Day-१ पर ९०% राहत (मरीज का कथन)",
    url: "https://www.youtube.com/watch?v=UmSyUkmMXYg",
  },
  {
    id: "2S0sAcS9pfY",
    title:
      "Varicose Veins & Knee Pain: २ दिन में ५०% राहत | Patient Testimonial",
    url: "https://www.youtube.com/watch?v=2S0sAcS9pfY",
  },
  {
    id: "wl7WZwfFgEc",
    title:
      "Varicose Veins: ३० मिनट में Before/After का स्पष्ट अंतर",
    url: "https://www.youtube.com/watch?v=wl7WZwfFgEc",
  },
  {
    id: "A_t1dUIfTvs",
    title:
      "बॉडी अलाइनमेंट, पाचन, फ़्रोज़न शोल्डर राहत | Bharat Dhara × Sevyam HiiMS",
    url: "https://www.youtube.com/watch?v=A_t1dUIfTvs",
  },
  {
    id: "5FO6j6OjH7g",
    title:
      "धन्यवाद संदेश / समर्पण",
    url: "https://www.youtube.com/watch?v=5FO6j6OjH7g",
  },
  {
    id: "S4T9Xd64OYc",
    title:
      "Bharat Dhara: जयपुर Day-2 —50% राहत | बिना दवा, प्राकृतिक राहत I पीठ/गर्दन दर्द में सुधार-70 years",
    url: "https://www.youtube.com/watch?v=S4T9Xd64OYc",
  },
  {
    id: "OhLgBKZGyZs",
    title:
      "Bharat Dhara - Jaipur Day 2 - महिलाओं की तकलीफ़ें,बस्ती, नाभि,  रीढ़ एलाइनमेंट, सीखें घर पर देखभाल",
    url: "https://www.youtube.com/watch?v=OhLgBKZGyZs",
  },
  {
    id: "FtjLAgGltWo",
    title:
      "Bharat Dhara - जयपुर Day-2 - थेरेपी, दर्द और टाइमलाइन—स्पष्ट मार्गदर्शन",
    url: "https://www.youtube.com/watch?v=FtjLAgGltWo",
  },
  {
    id: "hzAD12KmtGs",
    title:
      "Bharat Dhara: जयपुर Day-2 — बिस्किट vs तुलसी मसल टेस्ट डेमो",
    url: "https://www.youtube.com/watch?v=hzAD12KmtGs",
  },
  {
    id: "XcPzRl6UkWA",
    title:
      "Bharat Dhara: जयपुर Day2 — भरोसा, परिणाम और बिना ऑपरेशन Pain Relief के इंस्टेंट नतीजे—वास्तविक गवाही",
    url: "https://www.youtube.com/watch?v=XcPzRl6UkWA",
  },
  {
    id: "ye6EknVm1ao",
    title:
      "जयपुर—चंचल शर्मा (सर्जरी रेफ़रल केस):भारत धारा शिविर में Day-1 मुस्कान ही हमारी सबसे बड़ी कमाई—यही हमारी ‘फ़ीस’",
    url: "https://www.youtube.com/watch?v=ye6EknVm1ao",
  },
  {
    id: "syb3-c2cesw",
    title:
      "खतौली में भारतधारा नेचुरोपैथी चिकित्सा पद्धति द्वारा इलाज किया जा रहा है मरीज को बहुत आराम है",
    url: "https://www.youtube.com/watch?v=syb3-c2cesw",
  },
  {
    id: "8fu0CuqFt1c",
    title:
      "खतौली में निशुल्क भारतधारा नेचुरोपैथी द्वारा इलाज शुरू मरीजों की लगी लाइने",
    url: "https://www.youtube.com/watch?v=8fu0CuqFt1c",
  },

  {
    id: "3hpvA6pDtcg",
    title:
      "खतौली मे आवास विकास कालोनी मे 15 से 23 अगस्त तक लगाया गया प्राकर्तिक पद्द्ति पर आधारित चिकित्सा शिविर...",
    url: "https://www.youtube.com/watch?v=3hpvA6pDtcg",
  },
  {
    id: "2wgXWHwigp0",
    title: "खतौली में मुफ़्त मेगा शिविर का आयोजन किया गया।",
    url: "https://www.youtube.com/watch?v=2wgXWHwigp0",
  },
  {
    id: "_BvfGhYE6Wo",
    title:
      "खतौली आवास विकास में भारतधारा नेचुरल फार्मिंग द्वारा होगा सभी बीमारियों का इलाज",
    url: "https://www.youtube.com/watch?v=_BvfGhYE6Wo",
  },
  {
    id: "JdeQU2ewO2k",
    title:
      "खतौली आवास विकास कालोनी में भारत धारा निशुल्क स्वास्थ्य परामर्श पूर्ण बॉडी चेकअप शिविर पहुंचे सैकडो",
    url: "https://www.youtube.com/watch?v=JdeQU2ewO2k",
  },
  {
    id: "b22v3WYb8X8",
    title:
      "खतौली आवास विकास कॉलोनी में 15 से 24 अगस्त तक लगेगा आयुर्वेदिक स्वास्थ्य शिविर मुफ्त परामर्श ",
    url: "https://www.youtube.com/watch?v=b22v3WYb8X8",
  },
  {
    id: "H1XSPub8eQA",
    title:
      "खतौली मुजफ्फरनगर भारतधारा निशुल्क चिकित्सा शिविर में पहुंचे रालोद के राष्ट्रीय प्रवक्ता",
    url: "https://www.youtube.com/watch?v=H1XSPub8eQA",
  },
  {
    id: "prB-owXfr1Q",
    title:
      "भारत धारा थेरेपी | आयुर्वेद की शक्ति: पहले झुककर सामान नहीं उठा पाते थे, अब 70% राहत | ",
    url: "https://www.youtube.com/watch?v=prB-owXfr1Q&list=LL",
  },
  {
    id: "pzdD4Ls5_c4",
    title: "भारत धारा कैंप अनुभव : घुटनों के दर्द में लाभ ",
    url: "https://www.youtube.com/shorts/pzdD4Ls5_c4",
  },
  {
    id: "lBCtaMeaSfE",
    title: "Bharat Dhara Camp – Feedback (15–24 August 2025)",
    url: "https://www.youtube.com/watch?v=lBCtaMeaSfE",
  },
  {
    id: "_au-OV3Ggaw",
    title: "Bharat Dhara Song",
    url: "https://www.youtube.com/watch?v=_au-OV3Ggaw",
  },
  {
    id: "9lNfieGBxuE",
    title: "Shirodhara - Khatauli Camp - Prashant and Anjali ji on Seva",
    url: "https://www.youtube.com/watch?v=9lNfieGBxuE",
  },
  {
    id: "wNBDitiF98Q",
    title: "Yoga - Khatauli Camp - Swami Jeevanand",
    url: "https://www.youtube.com/watch?v=wNBDitiF98Q",
  },
];

export default YoutubeNews;
